module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-ExtraBold.bd2f9884.woff2";